import styled from '@emotion/styled';

import { theme } from '@ublend-npm/aulaui-next';

export const TemplatePreviewContainer = styled.section`
  background-color: ${theme.color.designSystem.grey10};
  width: 100%;
  overflow-y: auto;
`;

export const TemplatePreviewContainerInner = styled.div`
  padding: ${theme.spacing.xxxxLarge};
`;

export const TemplatePreviewTitle = styled.div`
  font-size: 48px;
  line-height: 56px;
  font-weight: ${theme.font.weight.regular};
`;

export const TemplatePreviewDescription = styled.p`
  margin-top: ${theme.spacing.small};
  margin-bottom: ${theme.spacing.medium};
  font-size: ${theme.font.size.large};
  line-height: ${theme.font.lineHeight.large};
  font-weight: ${theme.font.weight.regular};
  color: ${theme.color.designSystem.blackOpacity87};
`;

export const TemplatePreviewContent = styled.div`
  border-radius: 4px;
  padding: ${theme.spacing.xxSmall} ${theme.spacing.large};
  background-color: ${theme.color.white};
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.2), 0px 3px 3px rgba(0, 0, 0, 0.12),
    0px 3px 4px rgba(0, 0, 0, 0.14);
`;
